import { getStaticPathsGenerator } from '@cinch-nx/landing-feature-store-page'

export { getStaticProps } from '@cinch-nx/landing-feature-store-page'

const path = 'store'
export const getStaticPaths = getStaticPathsGenerator(path)

export { LandingFeatureStorePage as default } from '@cinch-nx/landing-feature-store-page'
